var map = {
	"./admin_settings.png": 1844,
	"./appraisals.png": 1845,
	"./catalog.png": 1846,
	"./catalogWhite.png": 1847,
	"./catalog_orders.png": 1848,
	"./cms.png": 1849,
	"./component-fields/Asset.png": 1850,
	"./component-fields/Blocks.png": 1851,
	"./component-fields/Boolean.png": 1852,
	"./component-fields/Date-time.png": 1853,
	"./component-fields/LInk.png": 1854,
	"./component-fields/Markdown.png": 1855,
	"./component-fields/Multi asset.png": 1856,
	"./component-fields/Multi options.png": 1857,
	"./component-fields/Number.png": 1858,
	"./component-fields/Richtext.png": 1859,
	"./component-fields/Single options.png": 1860,
	"./component-fields/Table.png": 1861,
	"./component-fields/Text area.png": 1862,
	"./component-fields/Text.png": 1863,
	"./components.png": 1864,
	"./configuration.png": 1865,
	"./contents.png": 1866,
	"./crm.png": 1867,
	"./custom_order.png": 1868,
	"./customer_credits.png": 1869,
	"./customer_list.png": 1870,
	"./dashboard.png": 1871,
	"./finance.png": 1872,
	"./home.png": 1873,
	"./integrations.png": 1874,
	"./inventory-transfers.png": 1875,
	"./invoice-list.png": 1876,
	"./layaway.png": 1877,
	"./move.png": 1878,
	"./new_sale.png": 1879,
	"./orders.png": 1880,
	"./outgoing-consignments.png": 1881,
	"./payment-methods/amex.png": 1192,
	"./payment-methods/discover.png": 1191,
	"./payment-methods/mastercard.png": 1190,
	"./payment-methods/visa.png": 1189,
	"./payments.png": 1882,
	"./plus.png": 1398,
	"./register.png": 1883,
	"./repair_center.png": 1884,
	"./reports.png": 1885,
	"./services.png": 1886,
	"./trade_in_center.png": 1887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1774;